import { useGet } from '../../../sharedModules/hooks/useQuery';

interface UseChillerJobApprovalsOptions {
  teamId?: string;
  location?: string;
  enabled?: boolean;
}

export function useChillerJobApprovals({ teamId, location, enabled }: UseChillerJobApprovalsOptions = {}) {
  const params: Record<string, any> = {
    'ransack[status_eq]': 'pending_approval',
    page: 1,
  };

  if (teamId) params['ransack[team_id_eq]'] = teamId;
  if (location) params['location'] = location;

  return useGet<{ result: any[]; total_records: number }>({ url: 'chiller_logs/chiller_logs', params, enabled });
}
